module.exports = __webpack_public_path__ + "img/landfill.bccf480d.png";